import {
    CLOSE_SLIDER,
    IS_SUBMITTING,
    OPEN_SLIDER,
    RESET_EDIT,
    RESET_FORM_STATUS,
    SELECTED_MENU_ITEM,
    SET_EDIT,
    SET_HEADER_BUTTON_PARAMS,
    SET_HEADER_TEXT,
    SUBMIT_ERROR,
    SUBMIT_SUCCESS,
    SETTINGS_IS_LOADING,
    SETTINGS_LOAD_SUCCESS,
    SETTINGS_LOAD_ERROR,
    ANNOUNCEMENTS_IS_LOADING,
    ANNOUNCEMENTS_LOAD_SUCCESS,
    ANNOUNCEMENTS_LOAD_ERROR,
    IS_UPDATING,
    UPDATE_SUCCESS,
    UPDATE_ERROR,
    STATISTICS_IS_LOADING,
    STATISTICS_LOAD_SUCCESS,
    STATISTICS_LOAD_ERROR,

    STATISTICS_PARTICIPANT_IS_LOADING,
    STATISTICS_PARTICIPANT_LOAD_SUCCESS,
    STATISTICS_PARTICIPANT_LOAD_ERROR,

    LEADERSHIP_BOARD_IS_LOADING,
    LEADERSHIP_BOARD_LOAD_SUCCESS,
    LEADERSHIP_BOARD_LOAD_ERROR,
    REPORTS_IS_LOADING,
    REPORTS_LOAD_SUCCESS,
    REPORTS_LOAD_ERROR,
    LIVE_COURSES_IS_LOADING,
    LIVE_COURSES_LOAD_SUCCESS,
    LIVE_COURSES_LOAD_ERROR,
    SET_ACCESS_TOKEN,
    RESET_ACCESS_TOKEN,
    SEARCH_AUTOCOMPLETE_LIST_LOADING,
    SEARCH_QUERY_LOADING,
    SEARCH_COMPONENT_RESET,
    SEARCH_FINAL_QUERY,
    SET_AUTOCOMPLETE_VISIBILITY,
    SET_HEADER_ADVANCED_SEARCH_PARAMS,
    SET_ADVANCED_SEARCH,
    RESET_ADVANCED_SEARCH,
    MONTH_IS_LOADING,
    MONTH_LOAD_SUCCESS,
    MONTH_LOAD_ERROR,
    SET_HOLIDAY_TYPE,
    SUBJECTS_IS_LOADING,
    SUBJECTS_LOAD_SUCCESS,
    SUBJECTS_LOAD_ERROR,
    SESSION_TIMINGS_IS_LOADING,
    SESSION_TIMINGS_LOAD_SUCCESS,
    SESSION_TIMINGS_LOAD_ERROR,
    CLASSES_IS_LOADING,
    CLASSES_LOAD_SUCCESS,
    CLASSES_LOAD_ERROR,
    TUTORS_IS_LOADING,
    TUTORS_LOAD_SUCCESS,
    TUTORS_LOAD_ERROR,
    STUDENTS_IS_LOADING,
    STUDENTS_LOAD_SUCCESS,
    STUDENTS_LOAD_ERROR,
    APPROVAL_BEGIN,
    APPROVAL_SUCCESS,
    APPROVAL_ERROR,
    APPROVAL_RESET,
    DEGREE_IS_LOADING,
    DEGREE_LOAD_SUCCESS,
    DEGREE_LOAD_ERROR,
    SPECIFICATION_LOAD_ERROR,
    SPECIFICATION_LOAD_SUCCESS,
    SPECIFICATION_IS_LOADING,

     EXAM_SPECIFICATION_LOAD_ERROR,
    EXAM_SPECIFICATION_LOAD_SUCCESS,
    EXAM_SPECIFICATION_IS_LOADING,
    
    GET_EXAM_IS_LOADING,
    GET_EXAM_LOAD_SUCCESS,
    GET_EXAM_LOAD_ERROR,
    DASHBOARD_BEGIN,
    DASHBOARD_SUCCESS,
    DASHBOARD_ERROR,
    ANNOUNCEMENTS_DATA_LOADING,
    ANNOUNCEMENTS_DATA_SUCCESS,
    ANNOUNCEMENTS_DATA_ERROR,
    REPORTS_STUDENT_LIST_IS_LOADING,
    REPORTS_STUDENT_LIST_LOAD_SUCCESS,
    REPORTS_STUDENT_LIST_LOAD_ERROR,
    REPORTS_TUTOR_LIST_IS_LOADING,
    REPORTS_TUTOR_LIST_LOAD_SUCCESS,
    REPORTS_TUTOR_LIST_LOAD_ERROR,
    REPORTS_STUDENT_STATISTICS_IS_LOADING,
    REPORTS_STUDENT_STATISTICS_LOAD_SUCCESS,
    REPORTS_STUDENT_STATISTICS_LOAD_ERROR,
    REPORTS_STUDENT_EXAM_SCHEDULE_IS_LOADING,
    REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_SUCCESS,
    REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_ERROR,

    REPORTS_TUTOR_STATISTICS_IS_LOADING,
    REPORTS_TUTOR_STATISTICS_LOAD_SUCCESS,
    REPORTS_TUTOR_STATISTICS_LOAD_ERROR,
    REPORTS_TUTOR_EXAM_SCHEDULE_IS_LOADING,
    REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_SUCCESS,
    REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_ERROR,

    REPORTS_STUDENT_EXAM_SCHEDULE_STATS_IS_LOADING,
    REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_SUCCESS,
    REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_ERROR,

    REPORTS_TUTOR_EXAM_SCHEDULE_STATS_IS_LOADING,
    REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_SUCCESS,
    REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_ERROR,

    SCHEDULE_IS_LOADING,
    SCHEDULE_LOAD_SUCCESS,
    SCHEDULE_LOAD_ERROR,

    ATTENDANCE_IS_LOADING,
    ATTENDANCE_LOAD_SUCCESS,
    ATTENDANCE_LOAD_ERROR,

    ATTENDANCE_ALL_IS_LOADING,
    ATTENDANCE_ALL_LOAD_SUCCESS,
    ATTENDANCE_ALL_LOAD_ERROR,

    ATTENDANCE_REPORT_IS_LOADING,
    ATTENDANCE_REPORT_LOAD_SUCCESS,
    ATTENDANCE_REPORT_LOAD_ERROR,

    ATTENDANCE_DATA_IS_LOADING,
    ATTENDANCE_DATA_LOAD_SUCCESS,
    ATTENDANCE_DATA_LOAD_ERROR

} from "./action_types";
const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
];

export const openSlider = () => ({
    type: OPEN_SLIDER,
});

export const closeSlider = () => ({
    type: CLOSE_SLIDER,
});

export const selectedMenu = (itemIndex) => ({
    type: SELECTED_MENU_ITEM,
    payload: itemIndex,
});

export const setHeaderButtonParams = (buttonParams) => ({
    type: SET_HEADER_BUTTON_PARAMS,
    payload: buttonParams,
});

export const setHeaderText = (text) => ({
    type: SET_HEADER_TEXT,
    payload: text,
});

export const setHeaderAdvancedSearchParams = (params) => ({
    type: SET_HEADER_ADVANCED_SEARCH_PARAMS,
    payload: params
})

export const isSubmittingForm = () => ({
    type: IS_SUBMITTING,
});

export const formSubmitSuccess = () => ({
    type: SUBMIT_SUCCESS,
});

export const formSubmitError = (errorMessage) => ({
    type: SUBMIT_ERROR,
    payload: errorMessage,
});

export const resetFormStatus = () => ({
    type: RESET_FORM_STATUS,
});

export const isUpdatingForm = () => ({
    type: IS_UPDATING,
});

export const formUpdateSuccess = () => ({
    type: UPDATE_SUCCESS,
});

export const formUpdateError = (errorMessage) => ({
    type: UPDATE_ERROR,
    payload: errorMessage,
});

export const setEdit = (id) => ({
    type: SET_EDIT,
    payload: id,
});

export const resetEdit = () => ({
    type: RESET_EDIT,
});

export const getRandomEmployees = () => {
    let numberOfEmployees = Math.floor(Math.random() * 10) + 1;
    let employeesArray = [];
    for (let i = 0; i < numberOfEmployees; i++) {
        employeesArray.push(
            "./images/people/" + (Math.floor(Math.random() * 20) + 1) + ".jpg"
        );
    }
    return employeesArray;
};

export const calculateDateRange = (start, end) => {
    const startDate = start.split("-");
    const endDate = end.split("-");
    if (startDate[0] === endDate[0]) {
        if (startDate[1] === endDate[1]) {
            return `${months[startDate[1] - 1]} ${startDate[2]} - ${endDate[2]}, ${
        startDate[0]
      }`;
        } else {
            return `${months[startDate[1] - 1]} ${startDate[2]} - ${
        months[endDate[1] - 1]
      } ${endDate[2]}, ${startDate[0]}`;
        }
    } else {
        return `${months[startDate[1] - 1]} ${startDate[2]}, ${startDate[0]} - ${
      months[endDate[1] - 1]
    } ${endDate[2]}, ${endDate[0]}`;
    }
};

export const formatDate = (date) => {
    const createdDate = date.split("-");
    return `Created on ${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
};

export const formatCalendarSlotDate = (date) => {
    const slotDate = new Date(date);
    let year = slotDate.getFullYear()
    let month = (Number(slotDate.getMonth()) + 1)
    let day = slotDate.getDate()
    return `${year}-${month < 10 ? '0'+month:month}-${day<10?'0'+day:day}`;
};

export const formatDateAnnouncements = (date) => {
    if(date){
        const createdDate = date.split("-");
        return `${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
    }

};
export const formatDateAnnouncement = (date) => {
    const createdDate = date.split("-");
    return `Created on ${months[createdDate[1] - 1]} ${createdDate[2]}, ${createdDate[0]}`;
};


export const getMonth = (date) => {
    console.log(date)
    const extractedMonth = date.split('-')[1]
    return months[extractedMonth - 1]
}

export const getDate = (date) => {
    return date.split('-')[2]
}

export const formatLiveCourseDateTime = (startTime) => {
    let startDateAndTime = new Date(Date.parse(startTime))
    let year = startDateAndTime.getFullYear()
    let month = (Number(startDateAndTime.getMonth()))
    let day = startDateAndTime.getDate()
    let hour = startDateAndTime.getHours()
    let minutes = startDateAndTime.getMinutes()
    return `${months[month]} ${day < 10 ? '0'+day : day}, ${year} at ${hour<10 ? '0'+hour:hour}:${minutes < 10 ? '0'+minutes : minutes} hrs`
}

export const settingsIsLoading = () => ({
    type: SETTINGS_IS_LOADING,
});

export const settingsLoadingSuccess = (settingsData) => ({
    type: SETTINGS_LOAD_SUCCESS,
    payload: settingsData,
});

export const settingsLoadingError = (errorMessage) => ({
    type: SETTINGS_LOAD_ERROR,
    payload: errorMessage,
});

export const announcementsIsLoading = () => ({
    type: ANNOUNCEMENTS_IS_LOADING,
});

export const announcementsLoadingSuccess = (announcementsData) => ({
    type: ANNOUNCEMENTS_LOAD_SUCCESS,
    payload: announcementsData,
});

export const announcementsLoadingError = (errorMessage) => ({
    type: ANNOUNCEMENTS_LOAD_ERROR,
    payload: errorMessage,
});

export const statisticsIsLoading = () => ({
    type: STATISTICS_IS_LOADING,
});

export const statisticsLoadingSuccess = (statisticsData) => ({
    type: STATISTICS_LOAD_SUCCESS,
    payload: statisticsData,
});

export const statisticsLoadingError = (errorMessage) => ({
    type: STATISTICS_LOAD_ERROR,
    payload: errorMessage,
});

export const statisticsParticpantsIsLoading = () => ({
    type: STATISTICS_PARTICIPANT_IS_LOADING,
});

export const statisticsParticpantsLoadingSuccess = (statisticParticipantsData) => ({
    type: STATISTICS_PARTICIPANT_LOAD_SUCCESS,
    payload: statisticParticipantsData,
});

export const statisticsParticpantsLoadingError = (errorMessage) => ({
    type: STATISTICS_PARTICIPANT_LOAD_ERROR,
    payload: errorMessage,
});

export const leadershipBoardIsLoading = () => ({
    type: LEADERSHIP_BOARD_IS_LOADING,
});

export const leadershipBoardLoadingSuccess = (leadershipBoardData) => ({
    type: LEADERSHIP_BOARD_LOAD_SUCCESS,
    payload: leadershipBoardData,
});

export const leadershipBoardLoadingError = (errorMessage) => ({
    type: LEADERSHIP_BOARD_LOAD_ERROR,
    payload: errorMessage,
});

export const reportsIsLoading = () => ({
    type: REPORTS_IS_LOADING,
});

export const reportsLoadingSuccess = (reportsData) => ({
    type: REPORTS_LOAD_SUCCESS,
    payload: reportsData,
});

export const reportsLoadingError = (errorMessage) => ({
    type: REPORTS_LOAD_ERROR,
    payload: errorMessage,
});

export const liveCoursesIsLoading = () => ({
    type: LIVE_COURSES_IS_LOADING,
});

export const liveCourseLoadingSuccess = (liveCoursesData) => ({
    type: LIVE_COURSES_LOAD_SUCCESS,
    payload: liveCoursesData,
});

export const liveCourseLoadingError = (errorMessage) => ({
    type: LIVE_COURSES_LOAD_ERROR,
    payload: errorMessage,
});

//temporary fix for storing access token for live sessions
export const setAccessToken = (token) => ({
    type: SET_ACCESS_TOKEN,
    payload: token
})

export const resetAccessToken = () => ({
    type: RESET_ACCESS_TOKEN
})

export const searchAutocompleteList = (list) => ({
    type: SEARCH_AUTOCOMPLETE_LIST_LOADING,
    payload: list
})

export const searchQuery = (query) => ({
    type: SEARCH_QUERY_LOADING,
    payload: query
})

export const searchFinal = (query) => ({
    type: SEARCH_FINAL_QUERY,
    payload: query
})

export const searchReset = () => ({
    type: SEARCH_COMPONENT_RESET
})

export const setAutocompleteVisibility = (value) => ({
    type: SET_AUTOCOMPLETE_VISIBILITY,
    payload: value
})

export const setAdvancedSearchParams = (params) => ({
    type: SET_ADVANCED_SEARCH,
    payload: params
})

export const resetAdvancedSearchParams = () => ({
    type: RESET_ADVANCED_SEARCH
})

export const monthIsLoading = () => ({
    type: MONTH_IS_LOADING
})

export const monthLoadingSuccess = (monthData) => ({
    type: MONTH_LOAD_SUCCESS,
    payload: monthData
})

export const monthLoadingError = (error) => ({
    type: MONTH_LOAD_ERROR,
    payload: error
})

export const setHolidayType = (data) => ({
    type: SET_HOLIDAY_TYPE,
    payload: data
})

export const subjectIsLoading = () => ({
    type: SUBJECTS_IS_LOADING,
});

export const subjectLoadingSuccess = (subjectData) => ({
    type: SUBJECTS_LOAD_SUCCESS,
    payload: subjectData,
});

export const subjectLoadingError = (errorMessage) => ({
    type: SUBJECTS_LOAD_ERROR,
    payload: errorMessage,
});

export const sessionTimingIsLoading = () => ({
    type: SESSION_TIMINGS_IS_LOADING,
});

export const sessionTimingLoadingSuccess = (sessionTimingData) => ({
    type: SESSION_TIMINGS_LOAD_SUCCESS,
    payload: sessionTimingData,
});

export const sessionTimingLoadingError = (errorMessage) => ({
    type: SESSION_TIMINGS_LOAD_ERROR,
    payload: errorMessage,
});

export const classesIsLoading = () => ({
    type: CLASSES_IS_LOADING,
});

export const classesLoadingSuccess = (classesData) => ({
    type: CLASSES_LOAD_SUCCESS,
    payload: classesData,
});

export const classesLoadingError = (errorMessage) => ({
    type: CLASSES_LOAD_ERROR,
    payload: errorMessage,
});

export const degreeIsLoading = () => ({
    type: DEGREE_IS_LOADING,
});

export const degreeLoadingSuccess = (degreeData) => ({
    type: DEGREE_LOAD_SUCCESS,
    payload: degreeData,
});

export const degreeLoadingError = (errorMessage) => ({
    type: DEGREE_LOAD_ERROR,
    payload: errorMessage,
});

export const specificationIsLoading = () => ({
    type: SPECIFICATION_IS_LOADING,
});

export const specificationLoadingSuccess = (degreeData) => ({
    type: SPECIFICATION_LOAD_SUCCESS,
    payload: degreeData,
});

export const specificationLoadingError = (errorMessage) => ({
    type: SPECIFICATION_LOAD_ERROR,
    payload: errorMessage,
});


export const ExamspecificationIsLoading = () => ({
    type: EXAM_SPECIFICATION_IS_LOADING,
});

export const ExamspecificationLoadingSuccess = (degreeData) => ({
    type: EXAM_SPECIFICATION_LOAD_SUCCESS,
    payload: degreeData,
});

export const ExamspecificationLoadingError = (errorMessage) => ({
    type: EXAM_SPECIFICATION_LOAD_ERROR,
    payload: errorMessage,
});

export const getExamIsLoading = () => ({
    type: GET_EXAM_IS_LOADING,
});

export const getExamLoadingSuccess = (getExamSchedules) => ({
    type: GET_EXAM_LOAD_SUCCESS,
    payload: getExamSchedules,
});

export const getExamLoadingError = (errorMessage) => ({
    type: GET_EXAM_LOAD_ERROR,
    payload: errorMessage,
});

export const tutorIsLoading = () => ({
    type: TUTORS_IS_LOADING,
});

export const tutorLoadingSuccess = (tutorsData) => ({
    type: TUTORS_LOAD_SUCCESS,
    payload: tutorsData,
});

export const tutorLoadingError = (errorMessage) => ({
    type: TUTORS_LOAD_ERROR,
    payload: errorMessage,
});

export const studentIsLoading = () => ({
    type: STUDENTS_IS_LOADING,
});

export const studentLoadingSuccess = (studentsData) => ({
    type: STUDENTS_LOAD_SUCCESS,
    payload: studentsData,
});

export const studentLoadingError = (errorMessage) => ({
    type: STUDENTS_LOAD_ERROR,
    payload: errorMessage,
});

export const beginApproval = () => ({
    type: APPROVAL_BEGIN,
});

export const approvalSuccess = () => ({
    type: APPROVAL_SUCCESS,
});

export const approvalError = (error) => ({
    type: APPROVAL_ERROR,
    payload: error
});

export const approvalReset = () => ({
    type: APPROVAL_RESET
})

// Dashboard Actions

export const getDashboardData = () => ({
    type: DASHBOARD_BEGIN,
});

export const dashboardSuccess = (data) => ({
    type: DASHBOARD_SUCCESS,
    payload: data,
});

export const dashboardError = (error) => ({
    type: DASHBOARD_ERROR,
    payload: error
});

// Dashboard Actions

export const getAnnouncementData = () => ({
    type: ANNOUNCEMENTS_DATA_LOADING,
});

export const getAnnouncementSuccess = (data) => ({
    type: ANNOUNCEMENTS_DATA_SUCCESS,
    payload: data,
});

export const getAnnouncementError = (error) => ({
    type: ANNOUNCEMENTS_DATA_ERROR,
    payload: error
});

export const reportStudentListIsLoading = () => ({
    type: REPORTS_STUDENT_LIST_IS_LOADING,
});

export const reportStudentListLoadingSuccess = (studentsData) => ({
    type: REPORTS_STUDENT_LIST_LOAD_SUCCESS,
    payload: studentsData,
});

export const reportStudentListLoadingError = (errorMessage) => ({
    type: REPORTS_STUDENT_LIST_LOAD_ERROR,
    payload: errorMessage,
});

export const reportTutorListIsLoading = () => ({
    type: REPORTS_TUTOR_LIST_IS_LOADING,
});

export const reportTutorListLoadingSuccess = (TutorsData) => ({
    type: REPORTS_TUTOR_LIST_LOAD_SUCCESS,
    payload: TutorsData,
});

export const reportTutorListLoadingError = (errorMessage) => ({
    type: REPORTS_TUTOR_LIST_LOAD_ERROR,
    payload: errorMessage,
});

export const reportStudentStatisticsIsLoading = () => ({
    type: REPORTS_STUDENT_STATISTICS_IS_LOADING,
});

export const reportStudentStatisticsLoadingSuccess = (studentStatisticsData) => ({
    type: REPORTS_STUDENT_STATISTICS_LOAD_SUCCESS,
    payload: studentStatisticsData,
});

export const reportStudentStatisticsLoadingError = (errorMessage) => ({
    type: REPORTS_STUDENT_STATISTICS_LOAD_ERROR,
    payload: errorMessage,
});

export const reportStudentExamScheduleIsLoading = () => ({
    type: REPORTS_STUDENT_EXAM_SCHEDULE_IS_LOADING,
});

export const reportStudentExamScheduleLoadingSuccess = (studentExamScheduleData) => ({
    type: REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_SUCCESS,
    payload: studentExamScheduleData,
});

export const reportStudentExamScheduleLoadingError = (errorMessage) => ({
    type: REPORTS_STUDENT_EXAM_SCHEDULE_LOAD_ERROR,
    payload: errorMessage,
});


export const reportTutorStatisticsIsLoading = () => ({
    type: REPORTS_TUTOR_STATISTICS_IS_LOADING,
});

export const reportTutorStatisticsLoadingSuccess = (tutorStatisticsData) => ({
    type: REPORTS_TUTOR_STATISTICS_LOAD_SUCCESS,
    payload: tutorStatisticsData,
});

export const reportTutorStatisticsLoadingError = (errorMessage) => ({
    type: REPORTS_TUTOR_STATISTICS_LOAD_ERROR,
    payload: errorMessage,
});

export const reportTutorExamScheduleIsLoading = () => ({
    type: REPORTS_TUTOR_EXAM_SCHEDULE_IS_LOADING,
});

export const reportTutorExamScheduleLoadingSuccess = (tutorExamScheduleData) => ({
    type: REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_SUCCESS,
    payload: tutorExamScheduleData,
});

export const reportTutorExamScheduleLoadingError = (errorMessage) => ({
    type: REPORTS_TUTOR_EXAM_SCHEDULE_LOAD_ERROR,
    payload: errorMessage,
});


export const reportStudentExamScheduleStatIsLoading = () => ({
    type: REPORTS_STUDENT_EXAM_SCHEDULE_STATS_IS_LOADING,
});

export const reportStudentExamScheduleStatLoadingSuccess = (studentExamScheduleStatsData) => ({
    type: REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_SUCCESS,
    payload: studentExamScheduleStatsData,
});

export const reportStudentExamScheduleStatLoadingError = (errorMessage) => ({
    type: REPORTS_STUDENT_EXAM_SCHEDULE_STATS_LOAD_ERROR,
    payload: errorMessage,
});

export const reportTutorExamScheduleStatIsLoading = () => ({
    type: REPORTS_TUTOR_EXAM_SCHEDULE_STATS_IS_LOADING,
});

export const reportTutorExamScheduleStatLoadingSuccess = (TutorExamScheduleStatsData) => ({
    type: REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_SUCCESS,
    payload: TutorExamScheduleStatsData,
});

export const reportTutorExamScheduleStatLoadingError = (errorMessage) => ({
    type: REPORTS_TUTOR_EXAM_SCHEDULE_STATS_LOAD_ERROR,
    payload: errorMessage,
});

export const scheduleIsLoading = () => ({
    type: SCHEDULE_IS_LOADING,
});

export const scheduleLoadingSuccess = (scheduleData) => ({
    type: SCHEDULE_LOAD_SUCCESS,
    payload: scheduleData,
});

export const scheduleLoadingError = (errorMessage) => ({
    type: SCHEDULE_LOAD_ERROR,
    payload: errorMessage,
});

export const attendanceIsLoading = () => ({
    type: ATTENDANCE_IS_LOADING,
});

export const attendanceLoadingSuccess = (attendanceData) => ({
    type: ATTENDANCE_LOAD_SUCCESS,
    payload: attendanceData,
});

export const attendanceLoadingError = (errorMessage) => ({
    type: ATTENDANCE_LOAD_ERROR,
    payload: errorMessage,
});

export const attendanceAllIsLoading = () => ({
    type: ATTENDANCE_ALL_IS_LOADING,
});

export const attendanceAllLoadingSuccess = (attendanceAllData) => ({
    type: ATTENDANCE_ALL_LOAD_SUCCESS,
    payload: attendanceAllData,
});

export const attendanceAllLoadingError = (errorMessage) => ({
    type: ATTENDANCE_ALL_LOAD_ERROR,
    payload: errorMessage,
});


export const attendanceReportIsLoading = () => ({
    type: ATTENDANCE_REPORT_IS_LOADING,
});

export const attendanceReportLoadingSuccess = (attendanceReportsData) => ({
    type: ATTENDANCE_REPORT_LOAD_SUCCESS,
    payload: attendanceReportsData,
});

export const attendanceReportLoadingError = (errorMessage) => ({
    type: ATTENDANCE_REPORT_LOAD_ERROR,
    payload: errorMessage,
});


export const attendanceDataIsLoading = () => ({
    type: ATTENDANCE_DATA_IS_LOADING,
});

export const attendanceDataLoadingSuccess = (attendanceDataAll) => ({
    type: ATTENDANCE_DATA_LOAD_SUCCESS,
    payload: attendanceDataAll,
});

export const attendanceDataLoadingError = (errorMessage) => ({
    type: ATTENDANCE_DATA_LOAD_ERROR,
    payload: errorMessage,
});